module.exports = __webpack_public_path__ + "media/images/icon_check-86855f618f3feb81d5b95c133119476d.svg";